import React from "react"

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Phone = ({className, ...restProps}) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1768 7.78286C10.1768 6.10786 11.5346 4.75 13.2096 4.75H26.7946C28.4696 4.75 29.8275 6.10786 29.8275 7.78286V32.2171C29.8275 33.8921 28.4696 35.25 26.7946 35.25H13.2096C11.5346 35.25 10.1768 33.8921 10.1768 32.2171V7.78286ZM21.7799 30.7191C21.7799 31.826 20.914 32.7234 19.8458 32.7234C18.7777 32.7234 17.9117 31.826 17.9117 30.7191C17.9117 29.6121 18.7777 28.7148 19.8458 28.7148C20.914 28.7148 21.7799 29.6121 21.7799 30.7191ZM17.0716 8.45363C16.7231 8.45363 16.4406 8.74624 16.4406 9.1072C16.4406 9.46816 16.7231 9.76077 17.0716 9.76077H22.958C23.3065 9.76077 23.589 9.46816 23.589 9.1072C23.589 8.74624 23.3065 8.45363 22.958 8.45363H17.0716Z"
      className={className}
    />
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Email = props => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 12.8319V28.674C7 29.4063 7.59368 30 8.32603 30H31.674C32.4063 30 33 29.4063 33 28.674V12.8315L20.5404 20.8412L19.9997 21.1889L19.4589 20.8412L7 12.8319ZM32.7805 10.595C32.5431 10.2365 32.1362 10 31.674 10H8.32603C7.86371 10 7.45665 10.2366 7.21933 10.5953L19.9997 18.8112L32.7805 10.595Z"
    />
  </svg>
)
